import EquityMarketAdminPanel from 'modules/trading/pages/EquityMarketAdminPanel';
import { EquityMarketAdminPanelProvider } from '../contexts/EquityMarketAdminPanelContext';

const EquityMarketAdminPanelContainer = () => (
  <EquityMarketAdminPanelProvider>
    <EquityMarketAdminPanel />
  </EquityMarketAdminPanelProvider>
);

export default EquityMarketAdminPanelContainer;
